/**
 * A super module that collects available sub-modules.
 * 
 * @author rhess <robin.hess@awi.de>
 * 
 * @namespace vef.viewer.templates
 * @memberof vef.viewer
 */

import * as DefaultViewer from './DefaultViewer.js';
export { DefaultViewer };